import { IContentViewModelProperty } from '~/interfaces/contentViewInterfaces'
import ContentViewModelProperty from '~/models/contentManagement/contentViewModelProperties/contentViewModelProperty'
import { IObjectModelProperty } from '~/interfaces/objectModelInterfaces'
import CharacterCount from '../../../../formability/form_builder/models/characterCounts/characterCount'
import { ObjectModelPropertyName, ObjectModelPropertyRootType } from '~/enums/objectModelPropertyType'
import { DatetimeMode } from '~/models/datetimeMode'
import InputFormatDefinition from '~/models/inputFormatDefinition'

export default class ContentViewModelPropertyObjectModelProperty extends ContentViewModelProperty implements IContentViewModelProperty {
  constructor(public property: IObjectModelProperty) {
    super(property)
  }

  get canHaveCharacterCount(): boolean {
    return this.property.canHaveCharacterCount
  }

  get canHaveFormat(): boolean {
    return this.property.canHaveFormat
  }

  get character_count(): CharacterCount {
    return this.property.character_count
  }

  get format(): string {
    return this.property.format_type ? InputFormatDefinition.getDisplayName(this.property.format_type) : "None"
  }

  get hasMinOrMaxLength(): boolean {
    return this.property.hasMinOrMaxLength
  }

  get isMappedProperty(): boolean {
    return this.property.property_type === ObjectModelPropertyRootType.MappedProperty
  }

  get isDateTime(): boolean {
    return this.property.property_type === ObjectModelPropertyRootType.DateTime || (this.property.property_type === ObjectModelPropertyRootType.MappedProperty && this.property.mapped_property_type === ObjectModelPropertyRootType.DateTime)
  }

  get datetimeMode(): DatetimeMode {
    if (this.property.property_type === ObjectModelPropertyRootType.MappedProperty) {
      //Check to see if we are mapping over a default property
      return this.property.linked_relation_mapped_properties[0].default_property ? DatetimeMode.Datetime : this.property.mapped_property_datetime_mode
    } else {
      return this.property.datetime_mode
    }
  }

  get name(): string {
    return ObjectModelPropertyName(this.property)
  }

  get charLimit(): string {
    if (!this.property.hasMinOrMaxLength) {
      return "None"
    } else if (this.property.character_count.min && !this.property.character_count.max) {
      return `${this.property.character_count.min} Character Minimum`
    } else if (!this.property.character_count.min && this.property.character_count.max) {
      return `${this.property.character_count.max} Character Maximum`
    } else if (this.property.character_count.min === this.property.character_count.max) {
      return `${this.property.character_count.min} Characters`
    } else {
      return `${this.property.character_count.min} - ${this.property.character_count.max} Characters`
    }
  }

}